import styled from '@mui/system/styled';
import COLORS from '../../styles/Colors';

export const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
});

export const Box = styled('div')(({ checked }) => ({
  width: 20,
  height: 20,
  borderRadius: 4,
  border: `2px solid ${COLORS.PRIMARY}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: checked ? COLORS.PRIMARY : COLORS.WHITE,
  transition: '0.2s ease',
}));

export const CheckIcon = styled('span')({
  fontSize: 14,
  lineHeight: 1,
  color: COLORS.WHITE,
});

export const Label = styled('span')(({ checked }) => ({
  color: checked ? COLORS.PRIMARY : COLORS.BLACK,
  transition: '0.2s ease',
}));
